import React, { useMemo, useRef, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Form, Input, Button, message } from 'antd';
import { PostCaptcha, VerifyCaptcha } from '@store/session/service';
import { useSessionState, useAuthorization } from '@store/session';
import { MobilePhoneRegExp, classNames, NOOP, isString } from '@src/utils';
var prefixCls = 'captcha-form';
var initialValues = { mobile: '', captcha: '' };
var CaptchaForm = function (props) {
    var _a = useState(false), submitting = _a[0], setSubmitting = _a[1];
    // const [postSubmitting, setPostSubmitting] = useState(false)
    var dispatch = useDispatch();
    var _b = useState('发送验证码'), captchaStatus = _b[0], setCatchaStatus = _b[1];
    var _c = useState(0), countdown = _c[0], setCountdown = _c[1];
    var formRef = useRef(null);
    var token = useAuthorization();
    var _d = useSessionState(), posting = _d.posting, postingError = _d.postingError, verifying = _d.verifying, verifyingError = _d.verifyingError;
    var className = useMemo(function () {
        return classNames(prefixCls, props.className);
    }, [props.className]);
    var handleOnFinish = function (values) {
        dispatch(VerifyCaptcha({
            token: token,
            mobile: values.mobile,
            type: '1',
            vererificationCode: values.captcha,
        }));
        setSubmitting(true);
    };
    var handlePostCaptcha = function () {
        var _a;
        /** 表单校验通过后，发送验证码 */
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.validateFields(['mobile']).then(function (values) {
            /** 开始计时 */
            setCountdown(60);
            dispatch(PostCaptcha({ mobile: values.mobile, type: '1', token: token }));
        }).catch(NOOP);
    };
    /** 是否禁用下一步 */
    // const disabled = useMemo(() => {
    //   return (
    //     posting === void 0 ||
    //     posting === true ||
    //     (posting === false && isString(postingError))
    //   )
    // }, [posting, postingError])
    /** 发送验证码状态 */
    useEffect(function () {
        if (posting === false && isString(postingError)) {
            message.error({ content: postingError });
        }
    }, [posting, postingError]);
    /** 校验验证码状态 */
    useEffect(function () {
        var _a;
        if (verifying !== false || submitting !== true) {
            return void 0;
        }
        setSubmitting(false);
        if (verifying === false && isString(verifyingError)) {
            message.error({ content: verifyingError });
        }
        // 验证码校码成功，进入到下一步骤
        else if (verifying === false && isString(verifyingError) === false) {
            (_a = props.onFinish) === null || _a === void 0 ? void 0 : _a.call(null, 1);
        }
    }, [verifying, verifyingError, submitting, props.onFinish]);
    /** 重新发送验证码计时器 */
    useEffect(function () {
        var timer;
        if (countdown === 0) {
            setCatchaStatus('发送验证码');
        }
        else {
            setCatchaStatus("\u91CD\u65B0\u53D1\u9001(" + countdown + "\u79D2)");
            timer = window.setTimeout(function () { return setCountdown(countdown - 1); }, 1000);
        }
        return function () { return window.clearTimeout(timer); };
    }, [countdown]);
    return (React.createElement(Form, { ref: formRef, className: className, initialValues: initialValues, onFinish: handleOnFinish },
        React.createElement(Form.Item, { name: "mobile", className: prefixCls + "_mobile", validateTrigger: ['onChange', 'onBlur'], rules: [
                {
                    required: true,
                    message: '请输入正确的手机号',
                    pattern: MobilePhoneRegExp,
                    validateTrigger: 'onBlur',
                },
            ] },
            React.createElement(Input, { placeholder: "\u624B\u673A\u53F7", size: "large" })),
        React.createElement(Form.Item, { name: "captcha", className: prefixCls + "_captcha", validateTrigger: ['onChange', 'onBlur'], rules: [
                {
                    required: true,
                    message: '请输入验证码',
                    whitespace: true,
                    validateTrigger: 'onBlur',
                },
            ], extra: React.createElement(Button, { type: "link", onClick: handlePostCaptcha, loading: posting, disabled: countdown !== 0, size: "large" }, captchaStatus) },
            React.createElement(Input, { placeholder: "\u77ED\u4FE1\u9A8C\u8BC1\u7801", size: "large" })),
        React.createElement(Form.Item, null,
            React.createElement(Button, { type: "primary", block: true, loading: verifying, size: "large", onClick: function () { var _a; return (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.submit(); } }, "\u4E0B\u4E00\u6B65"))));
};
export default React.memo(CaptchaForm);
